import { search } from "../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/big-data/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findByCNPJ(cnpj = "") {
  return search(
    `${path}/company/${cnpj.replace(/[^0-9]+/g, "")}`,
    "GET",
    headers
  );
}

export async function findByCPF(cpf = "", birthDate = "") {
  return search(
    `${path}/person/${cpf.replace(/[^0-9]+/g, "")}?birthDate=${birthDate}`,
    "GET",
    headers
  );
}

export async function findByCEP(cep = "") {
  return search(
    `${path}/postal-code/${cep.replace(/[^0-9]+/g, "")}`,
    "GET",
    headers
  );
}
